var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDurationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy-3",
    transform: "translate(-785.000000, -731.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M797.5,731 C790.596458,731 785,736.596501 785,743.5 C785,750.403461 790.596458,756 797.5,756 C804.403542,756 810,750.403461 810,743.5 C810,736.596501 804.403542,731 797.5,731 Z M797.5,735.583335 C797.96025,735.583335 798.333333,735.956418 798.333333,736.416668 L798.333333,743.018256 L803.333333,745.908838 C803.731917,746.139047 803.862958,746.643088 803.632833,747.041671 C803.402625,747.440254 802.898625,747.571296 802.5,747.341171 C800.696667,746.300588 798.880167,745.252339 797.083333,744.216173 C796.834625,744.071964 796.666667,743.808173 796.666667,743.500006 L796.666667,736.416672 C796.666667,735.956423 797.03975,735.583335 797.5,735.583335 L797.5,735.583335 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/duration-icon.bd3ba08810e6e03dfa25614bd51a6079.svg";
export { ForwardRef as ReactComponent };